import { useMutation } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import { IUseUpdateAndroidTVHomeOrderMutationResponse } from "../utils/types";

const useUpdateAndroidTVHomeOrder = (): IUseUpdateAndroidTVHomeOrderMutationResponse =>
  useMutation({
    mutationFn: async (data) => {
      const response = await AXIOS_RESERVATION.put(
        "update-android-tv-home-order",
        data
      );
      return response.data;
    },
  });

export default useUpdateAndroidTVHomeOrder;
